import { render, staticRenderFns } from "./Fichar.vue?vue&type=template&id=5d9ca1ab&"
import script from "./Fichar.vue?vue&type=script&lang=js&"
export * from "./Fichar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports